import { Vue } from "vue-class-component";
import { assetsModule } from "@/store";
import { AssetsInterface, FoldersWithAssetsInterface } from "@/types";
import { hasAccessToAsset } from "@/utils/assetAccessChecker";
import { extractNestedAssets } from "@/utils/albumHelpers";
import { hasTextContent } from "@/utils";

export default class AssetDescriptionAccessMixin extends Vue {
  protected getAlbumsForContext(
    isDesktop?: boolean
  ): FoldersWithAssetsInterface[] {
    if (isDesktop) {
      return assetsModule.getFilteredAlbums;
    }

    return assetsModule.getFoldersWithAssets;
  }

  protected getAssetsBySlug(
    slug: string | undefined,
    isDesktop?: boolean
  ): AssetsInterface[] {
    const albums = this.getAlbumsForContext(isDesktop);
    return extractNestedAssets(albums);
  }

  protected getCurrentAssetBySlug(
    slug: string | undefined,
    isDesktop?: boolean
  ): AssetsInterface | undefined {
    if (!slug) {
      return undefined;
    }

    const assets = this.getAssetsBySlug(slug, isDesktop);
    return assets.find((a) => a.slug === slug);
  }

  protected isDescriptionDisabledForSlug(
    slug: string | undefined,
    isDesktop?: boolean
  ): boolean {
    const asset = this.getCurrentAssetBySlug(slug, isDesktop);

    if (!asset) {
      return true;
    }

    const hasAccess = hasAccessToAsset(asset);
    const hasDescription = hasTextContent(asset.description ?? "");

    return !hasAccess || !hasDescription;
  }
}
